import axios from './axios';
import { FileListResponse, FileListReq, FileSummaryResponse, FileTypes, FileTranscriptResponse } from '../types/file';

export const fileList = async (param: FileListReq): Promise<FileListResponse> => {
  const response = await axios.get(`/api3/ai/recording/list?${param?.sourceType ? `sourceType=${param.sourceType}&` : ''}pageNum=${param.pageNum}&pageSize=${param.pageSize || 30}`);
  return response.data.data;
};

export const sourceTypeList = async (): Promise<FileTypes> => {
  const response = await axios.get(`/api3/ai/recording/sourceTypeList`);
  return response.data.data;
};

// 总结详情
export const summaryDetail = async (id: number): Promise<FileSummaryResponse> => {
  const response = await axios.get(`/api3/v2/ai/transcript/summary?recordingId=${id}`);
  return response.data.data;
};

// 转写详情
export const transcriptDetail = async (id: number): Promise<FileTranscriptResponse> => {
  const response = await axios.get(`/api3/v2/ai/transcript/detail?recordingId=${id}`);
  return response.data.data;
};

// 删除文件
export const deleteFile = async (params: { recordingId: number }): Promise<any> => {
  const response = await axios.post(`/api3/ai/recording/delete`, params);
  return response.data;
};

// 重命名文件
export const renameFile = async (recordingId: number, fileName: string): Promise<any> => {
  const response = await axios.post(`/api3/ai/recording/updateName`, {
    recordingId,
    fileName
  });
  return response.data;
};

// 重新转写
export const retranscribeFile = async (params: { recordingId: number }): Promise<any> => {
  const response = await axios.post(`/api3/v2/ai/transcript/retry`, params);
  return response.data.data;
};

// 转写
export const transcribeFile = async (params: {
  "recordingId": number,
  "recordingLanguage": string,
  "type": string
}): Promise<any> => {
  const response = await axios.post(`/api3/v2/ai/transcript/commit`, params);
  return response.data.data;
};

// 重新总结
export const resummarizeFile = async (params: { recordingId: number }): Promise<any> => {
  const response = await axios.post(`/api3/v2/ai/summary/retry`, params);
  return response.data.data;
};
